import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import OktaVue from '@okta/okta-vue';
import { oktaAuth } from '@/auth';
import router from '@/router';
import App from '@/App.vue';
import '@/css/main.css';
import '@/css/tailwind.css';

const app = createApp(App);
const pinia = createPinia();

if (import.meta.env.VITE_ENV && import.meta.env.VITE_ENV !== 'Local') {
  Sentry.init({
    dsn: 'https://91b0e79f19d85e57cf603193c61bcbff@o299618.ingest.sentry.io/4506817382907904',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost'],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.VITE_ENV || 'none'
  });
}

app.use(OktaVue, { oktaAuth });
app.use(pinia);
app.use(router);
app.mount('#app');
